import React from "react";
import { ImageWithSkeleton } from "../../../components/ImageWithSkeleton/ImageWithSkeleton";

const PROFILE_IMG = "https://i.ibb.co/y5RctbT/profile.png";

const About = () => {
  return (
    <section id="about" className="about" data-aos="fade-up">
      <div className="about__inner">
        <h2 className="about__title">Backstory</h2>
        <div className="about__grid">
          <ImageWithSkeleton
            variant="about"
            className="about__photo"
            src={PROFILE_IMG}
            alt="Hassan Zahar Rifat"
            width={268}
            height={340}
          />
          <div className="about__text">
            <p>
              I grew up inside products with real users—first helping teams run
              on HR and ops software, then spending serious time in the JoomShaper
              / Ollyo orbit: SP Page Builder, EasyStore, and a Popup Builder launch
              that had to survive contact with actual merchants.
            </p>
            <p>
              These days I split energy between contract-shaped problems and my own
              bets: Formit, Cellmate AI, MirrorWhale, and smaller experiments that
              teach me something even when they don’t become a headline.
            </p>
            <p>
              If that sounds like your world—small team, scary scope, high
              taste—I’m easy to reach. Also: I drink more tea than is medically
              advisable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
